export const content = `All communication outside of your session will occur through your provider’s email, unless specified otherwise.

1. From your dashboard, look for the section about **Your Care Team**.
2. Find your current therapist and their email address.

![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXdr3Rwk9Jdg3FchiBHT_Ko5VZkDy6QsWAlrwRcqLlSQ8BiJwxjdj-YmJrkIzdk8qdZlY5l7YUSdDGzlAoaQ1c7k6Qfecm2gZTTGQCkaDAwcrtms1OJI-nra1XiUmFvRWY4jziITAw?key=VtL8rUtxDsPjOX4EA8jD-Fpd)
`;
